import { getApplicationStatusLabel, normalizeApplicationStatus, normalizeDecisionOutcome, normalizeStatusKey } from './applicationStatus';

// Presentation only: completion and permissions still belong to the existing workflow.
export function getApplicationOverviewStatus({ status, decisionOutcome, closureReason, applicationId, caseContext, checklistItems = null }) {
  const key = normalizeApplicationStatus(status);
  const closure = normalizeStatusKey(closureReason);
  const outcome = normalizeDecisionOutcome(decisionOutcome);
  const outcomeLabel = { approved: 'Approved', denied: 'Denied' }[outcome];
  const result = { label: getApplicationStatusLabel(status), pending: [] };
  if (normalizeStatusKey(status) === 'withdrawn' || (key === 'closed' && closure === 'withdrawn')) {
    return { label: 'Withdrawn', pending: [] };
  }
  if (['closed', 'completed'].includes(key)) {
    return { ...result, label: outcomeLabel && !['administrative', 'withdrawn'].includes(closure) ? `Complete — ${outcomeLabel}` : result.label };
  }
  if (!['decision_recorded', 'approved', 'rejected'].includes(key) || !outcomeLabel) return result;
  result.label = outcomeLabel;

  // Never borrow a sibling application's letter, or an unscoped legacy send.
  if (!applicationId || !caseContext || typeof caseContext !== 'object') return result;
  const context = caseContext.applicationDecisionLetters?.[String(applicationId)] || {};
  const letterType = outcome === 'approved' ? 'approval' : 'denial';
  const sent = (context.decisionLetterSent || context.decision_letter_sent)?.[letterType] ||
    ((context.decisionLetterSentType || context.decision_letter_sent_type) === letterType &&
      (context.decisionLetterSentAt || context.decision_letter_sent_at));
  if (!sent) result.pending.push(`${outcome === 'approved' ? 'Approval' : 'Denial'} letter not sent`);
  if (outcome === 'approved' && Array.isArray(checklistItems)) {
    const missing = checklistItems.filter(item => item && item.required !== false && item.status !== 'complete');
    const categories = new Set();
    missing.forEach(item => {
      const types = (item.documentTypes || []).map(normalizeStatusKey);
      if (types.includes('assessment_approval_letter')) return; // A generated letter does not prove it was sent.
      if (types.includes('funding_agreement')) categories.add('Funding agreement pending');
      else if (types.some(type => ['eft_form', 'eft_or_wire_transfer_form', 'eft_or_wire_transfer_direct_deposit_form', 'voided_cheque'].includes(type))) categories.add('Payment form pending');
      else categories.add('Required documents pending');
    });
    result.pending.push(...categories);
    if (sent && missing.length === 0) result.pending.push('Ready to complete');
  }
  if (outcome === 'denied' && sent) result.pending.push('Ready to complete');
  return result;
}
